import { Progress } from 'antd';

const getIntensityPercent = <T extends string>(
  intensity: T | null | undefined,
  infoText: T[],
): number => {
  if (!intensity) return 0;
  const intensityStr = String(intensity).toLowerCase();

  const index = infoText.findIndex(
    (text) => String(text).toLowerCase() === intensityStr,
  );
  if (index === -1) return 0;

  if (index === 0) return 25;

  return (index / (infoText.length - 1)) * 100;
};

export const WineProfileItem = <T extends string>({
  title,
  value,
  infoText,
}: {
  title: string;
  value?: T | null;
  infoText: T[];
}) => {
  return (
    <div className="flex flex-col gap-0.5">
      <h4 className="text-lg font-bold">{title}</h4>
      <div>
        <Progress
          showInfo={false}
          percent={getIntensityPercent(value, infoText)}
          strokeColor="rgb(123, 23, 217)"
        />
        <div className="flex justify-between items-center">
          {infoText.map((text) => (
            <span key={text} className="text-sm text-gray-500">
              {text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
